"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var ProgressBar = __importStar(require("./O_ProgressGroup"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var UploadFile_1 = __importDefault(require("@mui/icons-material/UploadFile"));
var function_1 = require("fp-ts/lib/function");
var O = __importStar(require("fp-ts/Option"));
var Arr = __importStar(require("fp-ts/Array"));
var checkCircle_1 = require("./icons/checkCircle");
var alertHexagon_1 = require("./icons/alertHexagon");
var Button = __importStar(require("./A_Button"));
var ButtonCombo = __importStar(require("./M_ButtonComboHeader"));
var isHtmlInput = function (e) { return e != null && e.files !== undefined; };
var Component = function (p) {
    //TODO: make separate components for each state to avoid confusion
    var completedText = p.succeeded ? 'complete' : 'failed';
    var completedIcon = p.succeeded ? (Preact.h(checkCircle_1.CheckCircle, { color: "success", fontSize: "large" })) : (Preact.h(alertHexagon_1.AlertHexagon, { color: "error", fontSize: "large" }));
    return (Preact.h(Dialog_1.default, { open: p.show },
        Preact.h(Box_1.default, { sx: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '16px',
                padding: '46px',
                width: '481px',
                height: '423px',
                boxSizing: 'border-box',
            } },
            p.loading && (Preact.h(ProgressBar.Component, { sx: {
                    paddingX: '64px',
                    paddingTop: 0,
                    paddingBottom: 0,
                    boxSizing: 'border-box',
                } })),
            p.completed && (Preact.h(Box_1.default, { sx: { marginBottom: '35px', textAlign: 'center' } },
                Preact.h(Box_1.default, { sx: { marginBottom: '24px' } }, completedIcon),
                Preact.h(Typography_1.default, { variant: "h5" }, "Upload ".concat(completedText)))),
            !p.loading && !p.completed && (Preact.h(Box_1.default, null,
                Preact.h("div", { id: "file_drop", onDrop: function (e) {
                        var _a;
                        e.preventDefault();
                        var file = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files[0];
                        if (file) {
                            p.onFileReady(file);
                        }
                    }, onDragOver: function (e) { return e.preventDefault(); } },
                    Preact.h(Box_1.default, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: 0,
                        } },
                        Preact.h(Button_1.default, { component: "label", sx: { padding: '25px' } },
                            Preact.h(UploadFile_1.default, { sx: {
                                    color: 'primary.main',
                                    fontSize: 72,
                                } }),
                            Preact.h("input", { type: "file", hidden: true, accept: ".csv", onChange: function (e) {
                                    (0, function_1.pipe)(e.target, O.fromNullable, O.filter(isHtmlInput), O.chain(function (input) { return (0, function_1.pipe)(input.files, O.fromNullable); }), O.chain(function (files) { return (0, function_1.pipe)(Array.from(files), Arr.head); }), O.map(function (file) {
                                        p.onFileReady(file);
                                    }));
                                } })))),
                Preact.h(Typography_1.default, { variant: "h4", sx: { marginY: '35px', textAlign: 'center' } }, "Click to upload CSV"),
                Preact.h(Box_1.default, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginBottom: '35px',
                    } },
                    Preact.h(Typography_1.default, { variant: "body1", sx: { marginBottom: '8px' } }, "Need our CSV template?"),
                    Preact.h(Link_1.default, { variant: "body1" }, "Download template")))),
            !p.failed && !p.loading && (Preact.h(Button.Component, { variant: "contained", onClick: p.onCloseClick }, "Close")),
            p.failed && (Preact.h(ButtonCombo.Component, { secondaryText: "Try again", secondaryAction: p.onTryAgainClick, primaryText: "Close", primaryAction: p.onCloseClick })))));
};
exports.Component = Component;
